import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../../services/storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const token = storage.token();

  // Skip auth for public endpoints
  if (
    req.url.includes('/public/') ||
    req.url.includes('/login') ||
    req.url.includes('/changepw') ||
    req.url.includes('/admin/approve-user')
  ) {
    return next(req);
  }

  // Clone request and add Authorization header if token exists
  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + token,
      },
    });
    return next(authReq);
  }

  return next(req);
};
